/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/
import React from "react";

import { Typography, Box, Card, CardContent } from "@mui/material";
import { Effect, Setting } from "../../../utils/Interfaces";
import ListSetting from "./setting-renderers/ListSetting";
import { modifyGlobalSetting } from "./globalSettingsFunctions";
import { useAppDispatch } from "../../../app/hooks";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

export interface GlobalSettingProps {
    reloadSettings: Effect;
    setting: Setting;
}

const GlobalSetting = (props: GlobalSettingProps) => {
    const { reloadSettings, setting } = props;

    const dispatch: Dispatch<AnyAction> = useAppDispatch();

    return (
        <Box>
            <Card>
                <CardContent>
                    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }} marginBottom={2}>
                        <Typography variant="h6" fontWeight={"bold"}>
                            {setting.title}
                        </Typography>
                        <Box
                            component="div"
                            sx={{
                                display: "inline",
                                p: 1,
                                m: 1,
                                bgcolor: (theme) => (theme.palette.mode === "dark" ? "#101010" : "#fff"),
                                color: (theme) => (theme.palette.mode === "dark" ? "grey.300" : "grey.800"),
                                border: "1px solid",
                                borderColor: (theme) => (theme.palette.mode === "dark" ? "grey.800" : "grey.300"),
                                borderRadius: 2,
                                fontSize: "0.875rem",
                                fontWeight: "700",
                                margin: 0,
                            }}
                        >
                            {`${setting.datatype.toUpperCase()} ${setting.key}`}
                        </Box>
                    </Box>

                    <Typography marginBottom={2}>{setting.description}</Typography>
                    {setting.datatype === "list" && (
                        <ListSetting
                            reloadSettings={reloadSettings}
                            setting={setting}
                            updateSetting={(newValue: string) =>
                                modifyGlobalSetting(setting.key, newValue, dispatch, reloadSettings)
                            }
                        />
                    )}
                </CardContent>
            </Card>
            <Box sx={{ marginBottom: "10px" }} />
        </Box>
    );
};
export default GlobalSetting;
